(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ageva-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initAgevaHeroSlider(section) {
      if (!section) return;
      if (section.dataset.sliderInitialized === 'true') return;

      const slides = Array.from(section.querySelectorAll('[data-slide]'));
      const prevBtn = section.querySelector('[data-slider-prev]');
      const nextBtn = section.querySelector('[data-slider-next]');
      const dots = Array.from(section.querySelectorAll('[data-dot]'));

      if (slides.length <= 1) {
        section.dataset.sliderInitialized = 'true';
        return;
      }

      let current = 0;
      const autoplay = section.dataset.autoplay === 'true';
      const intervalTime = Number(section.dataset.autoplaySpeed) || 5000;
      let timer = null;

      function goTo(index) {
        current = (index + slides.length) % slides.length;

        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === current);
        });

        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === current);
        });
      }

      function next() {
        goTo(current + 1);
      }

      function prev() {
        goTo(current - 1);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function startAutoplay() {
        if (!autoplay) return;
        stopAutoplay();
        timer = setInterval(next, intervalTime);
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          next();
          startAutoplay();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          prev();
          startAutoplay();
        });
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goTo(Number(dot.dataset.index));
          startAutoplay();
        });
      });

      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);

      document.addEventListener('shopify:block:select', (event) => {
        const block = event.target.closest('.ageva-hero-slider__slide');
        if (!block || !section.contains(block)) return;

        const index = Number(block.dataset.index);
        goTo(index);
        stopAutoplay();
      });

      goTo(0);
      startAutoplay();

      section.dataset.sliderInitialized = 'true';
    }

    document.querySelectorAll('.ageva-hero-slider').forEach((section) => {
      initAgevaHeroSlider(section);
    });

    document.addEventListener('shopify:section:load', (event) => {
      const loadedSection = event.target.querySelector('.ageva-hero-slider') || event.target;

      if (
        loadedSection &&
        loadedSection.classList &&
        loadedSection.classList.contains('ageva-hero-slider')
      ) {
        loadedSection.dataset.sliderInitialized = 'false';
        initAgevaHeroSlider(loadedSection);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
